import { InternalError } from './internal.error';

export class ProjectNotFoundError extends InternalError {
  constructor(projectId: number, data: Record<string, unknown> = {}) {
    super('Project not found', { status: 404, data: { projectId, ...data } });
  }
}
